import { useConnectivity } from '@/hooks/useConnectivity';
import { isOfflineModeEnabled } from '@/services/offline/featureFlag';
import {
  OFFLINE_CAPABILITIES,
  OFFLINE_UNAVAILABLE_MESSAGE,
  isNavAvailableOffline,
} from '@/services/offline/offlineCapabilities';

// { available, offline, message } — `available` is always true when the org
// flag is off or the backend is reachable; re-renders on connectivity flips.
export function useOfflineCapability(key) {
  const { isOnline } = useConnectivity();
  const offline = isOfflineModeEnabled() && !isOnline;
  const available = !offline || OFFLINE_CAPABILITIES[key] === true;
  return { available, offline, message: OFFLINE_UNAVAILABLE_MESSAGE };
}

// Nav-item variant: isNavDisabled(name) is false for every item when the
// flag is off or online.
export function useOfflineNav() {
  const { isOnline } = useConnectivity();
  const offline = isOfflineModeEnabled() && !isOnline;
  return {
    isNavDisabled: (name) => offline && !isNavAvailableOffline(name),
  };
}
